import axios from "axios";
import * as CookieService from "../Cookie/CookieService";

const path = '/api/v1';

function formatDateToISO(date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}T00:00:00.000Z`;
}

export function getTodayHomework() {
    return axios.get(path.concat('/todayhomework'), CookieService.setHeaders());
}

export function getTodayVocabHomework() {
    return axios.get(path.concat('/vocabulary/todayhomework'), CookieService.setHeaders());
}

export function getHomework(date) {
    const requestParams = {
        params: {
            "date": formatDateToISO(date)
        },
        headers: CookieService.setHeader()
    };
    return axios.get(path.concat('/homework'), requestParams);
}

export function getMonthHomework(year, month) {
    const requestParams = {
        params: {
            "year": year,
            "month": month + 1
        },
        headers: CookieService.setHeader()
    };
    return axios.get(path.concat('/monthhomework'), requestParams);
}

export function getVocabHomework(date) {
    const requestParams = {
        params: {
            "date": formatDateToISO(date)
        },
        headers: CookieService.setHeader()
    };
    return axios.get(path.concat('/vocabulary/homework'), requestParams);
}

export function getReadingHomework(date, section, title) {
    const requestParams = {
        params: {
            date: formatDateToISO(date),
            section: section,
            title: title
        },
        headers: CookieService.setHeader()
    };
    return axios.get(path.concat('/reading/homework'), requestParams);
}

/*export function report(date, correctNum, totalNum, percentage, subject){

 const requestBody = {
 "homeworkDueDate" : date,
 "numberOfCorrectAnswer" : correctNum,
 "numberOfQuestion" : totalNum,
 "percentage" : percentage,
 "subject": subject
 };
 return axios.post(path.concat('/report'), requestBody, CookieService.setHeaders());
 }*/

export function report(reportVO) {
    return axios.post(path.concat('/report'), reportVO, CookieService.setHeaders());
}

export function reportVocab(reportVO) {
    return axios.post(path.concat('/report/vocab'), reportVO, CookieService.setHeaders());
}

export function reportReading(reportVO) {
    return axios.post(path.concat('/report/reading'), reportVO, CookieService.setHeaders());
}

export function insertCustomReport(userID, reportDto) {
    const uriEncoded = encodeURI('/api/v1/report/custom?userID=' + userID);
    return axios.post(uriEncoded, reportDto, CookieService.setHeaders());
}

export function getReports(userID, startDate, endDate) {
    const requestParams = {
        params: {
            "startDate": startDate,
            "endDate": endDate
        },
        headers: CookieService.setHeader()
    };
    const uriEncoded = encodeURI('/api/v1/reports?userID=' + userID + '&startDate=' + startDate + '&endDate=' + endDate);
    return axios.get(uriEncoded, CookieService.setHeaders());
}

export function getAccumulativeVocabHomework(grade, section, title, endIndex, accumulativeNum) {
    const requestParams = {
        params: {
            "grade": grade,
            "section": section,
            "title": title,
            "end": endIndex,
            "accumulativeNum": accumulativeNum
        },
        headers: CookieService.setHeader()
    };
    return axios.get(path.concat('/vocabulary/accumulative'), requestParams);
}

export function getTTS(text) {
    const requestParams = {
        params: { "text": text },
        headers: CookieService.setHeader()
    };
    return axios.get(path.concat('/vocabulary/tts'), requestParams);
}

export function getReadingContent(id) {
    const requestParams = {
        headers: CookieService.setHeader()
    };
    return axios.get(path.concat(`/reading/content/${id}`), requestParams);
}

export function createReadingSentence(createReadingSentenceMap) {
    const uriEncoded = encodeURI('/api/v1/reading/sentence');
    return axios.post(uriEncoded, createReadingSentenceMap, CookieService.setHeaders());
}


// WEBPACK FOOTER //
// ./src/services/Student/HomeworkService.js